import { AppRoute } from 'constants/AppRoute';

export function getCallingUrl(): string {
  return window.location.href
    .replace(AppRoute.UNAUTHORIZED, '')
    .replace(AppRoute.FORBIDDEN, '')
    .replace(AppRoute.ERROR, '');
}
